class VGSearch {
	constructor() {
		let search = this;

		// Classes
		this.classes = {
			container: 'search-advanced',
			form: 'search-advanced--form',
			wrapper: 'search-advanced--wrapper',
			loading: 'search-advanced--form-loader'
		};

		// Settings
		this.settings = {
			icons: {
				cross: '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 224.512 224.512" style="enable-background:new 0 0 224.512 224.512;" xml:space="preserve"><g><polygon style="fill:#010002;" points="224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254 0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254 "/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>'
			},
			overflow: true,
			categories: null,
			products: null,
			vendors: null
		};

		this.tmSearch = null;
		let _self = this;

		let $input = $('.' + _self.classes.form).find('.search');
		$('.' + _self.classes.loading).hide();

		$input.on('keyup', function (e) {
			$('.' + _self.classes.loading).show();
			let self = this;
			clearInterval(_self.tmSearch);
			_self.tmSearch = setTimeout(function () {
				search.searchRun($(self).val());
			}, 300);
		});

		$input.on('search', function () {
			$('.' + _self.classes.loading).show();
			search.searchRun($(this).val());
		});
	}

	searchRun(search) {
		if (typeof search === 'undefined') {
			search = $('.' + this.classes.form).find('.search').val();
		}

		let params = {
			search: search,
		}, searcher = this;

		$.get('/catalog/search/lookup', params, function (data) {
			if (data.view) {
				let $container = $('.' + searcher.classes.wrapper);
				$container.html(data.view);
				$('.' + searcher.classes.loading).hide();

				VegasCarousel.init();

				$('[data-modal]').click(function () {
					ModalVegas.init($(this));

					return false;
				});
			}
		});
	}

	toggle(btn) {
		if (document.body.classList.contains('search-open')) {
			this.close(btn);
		} else {
			this.open(btn);
		}

		return false;
	}

	open(btn) {
		document.body.classList.add('search-open');

		if (this.settings.overflow) {
			document.body.style.overflow = 'hidden';
		}

		btn.innerHTML = this.settings.icons.cross;
		btn.classList.add('search-toggle-cross');

		const input = document.querySelector('.' + this.classes.form + ' input');
		setTimeout(() => {
			if (input) {
				input.focus();
			}
		}, 1000);

		this.searchRun();
	}

	close(btn = null) {
		document.body.classList.remove('search-open');

		if (this.settings.overflow) {
			document.body.style.overflow = 'auto';
		}

		if (btn) {
			let icon = btn.dataset.vgIcon;
			if (icon) {
				btn.innerHTML = '<i class="' + icon + '"></i>';
				btn.classList.remove('search-toggle-cross');
			}
		} else {
			let buttons = document.querySelectorAll('[data-vg-toggle="search"]');
			if (buttons.length) {
				for (let btn of buttons) {
					let icon = btn.dataset.vgIcon;
					if (icon) {
						btn.innerHTML = '<i class="' + icon + '"></i>';
						btn.classList.remove('search-toggle-cross');
					}
				}
			}
		}
	}
}

function onReady() {
	let $search = document.querySelectorAll('[data-vg-toggle="search"]');
	if ($search.length) {
		for (let search of $search) {
			search.onclick = function () {
				new VGSearch().toggle(this);

				return false;
			}
		}
	}

	let $searchDismiss = document.querySelectorAll('[data-vg-dismiss="search"]');
	if ($searchDismiss.length) {
		for (let dismiss of $search) {
			dismiss.onclick = function () {
				new VGSearch().close();
			}
		}
	}

	document.onkeyup = function (e) {
		if (e.key === "Escape") {
			new VGSearch().close();
		}

		return false;
	};

	$(document).on('click', '[data-keysearch]', function () {
		let $input = $("#search-advanced .search");

		if ($input.length) {
			$input.val($(this).data('keysearch'));
			$input.trigger('search');
		}

		return false;
	});
}

document.addEventListener("DOMContentLoaded", onReady);

export default VGSearch;